<template>
  <div class="row">
    <modal :show.sync="modals" :showClose="false">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Customer Details</h5>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-input
            v-model="custName"
            label="Customer Name"
            type="email"
            placeholder="Customer Name"
          ></base-input>
          <base-input
            v-model="custPass"
            label="Password"
            type="email"
            placeholder="Password"
          ></base-input>
          <base-input
            v-model="custPIC"
            label="Person In Charge"
            type="email"
            placeholder="PIC"
          ></base-input>
        </div>
        <div class="col-sm-6">
          <base-input
            v-model="custAddress"
            label="Address"
            type="email"
            placeholder="Address"
          ></base-input>
          <base-input
            v-model="custNo"
            label="Telephone No"
            type="email"
            placeholder="Telephone No"
          ></base-input>
          <base-input
            v-model="custEmail"
            label="Email"
            type="email"
            placeholder="Email"
          ></base-input>
        </div>
      </div>

      <div
        class="col-sm-12 d-flex justify-content-between"
        style="margin-top: 1%"
      >
        <base-button type="success" @click="handleEdit(currentRow)"
          >Submit</base-button
        >
        <base-button type="warning" @click="modals = false">Cancel</base-button>
      </div>
    </modal>
    <div class="col-lg-8">
      <h2 class="inline">Customer Update</h2>
    </div>

    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">List of Customer</h4>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <base-input label="rows visible">
              <el-select
                class="select-info mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </base-input>
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            </base-input>
          </div>
          <el-table
            :data="queriedCustomerData"
            @row-dblclick="getCustomer"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            <el-table-column
              label="Customer Name"
              prop="CustName"
              :min-width="150"
            ></el-table-column>
            <el-table-column
              label="Address"
              prop="CustAddr"
              :min-width="150"
            ></el-table-column>
            <el-table-column
              v-if="false"
              prop="CustNo"
              :min-width="150"
            ></el-table-column>
            <el-table-column
              v-if="false"
              prop="CustID"
              :min-width="150"
            ></el-table-column>
            <el-table-column
              label="Person In Charge"
              prop="CustPic"
              :min-width="150"
            ></el-table-column>
            <el-table-column
              label="Email"
              prop="CustEmail"
              :min-width="150"
            ></el-table-column>
            <el-table-column
              label="Total Region"
              prop="TotalRegion"
              :min-width="150"
            ></el-table-column>
            <el-table-column :min-width="135" align="right" label="Actions">
              <div slot-scope="props">
                <el-tooltip content="Edit" placement="bottom" effect="light">
                  <base-button
                    @click="enterDefault()"
                    @click.native="getRow(props.$index, props.row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                </el-tooltip>
                <el-tooltip content="Delete" placement="bottom" effect="light">
                  <base-button
                    @click.native="handleDelete(props.$index, props.row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { BasePagination, Modal } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import Axios from "axios";

export default {
  components: {
    BasePagination,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedCustomerData() {
      let result = this.tableCustomerData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableCustomerData.length;
    },
  },

  data() {
    return {
      modals: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["CustName"],
      tableCustomerData: [],
      searchedData: [],
      fuseSearch: null,
      currentRow: null,
      custName: "",
      custPass: "",
      custPIC: "",
      custAddress: "",
      custNo: "",
      custEmail: "",
    };
  },

  methods: {
    enterDefault() {
      this.custName = "";
      this.custNo = "";
      this.custPIC = "";
      this.custEmail = "";
      this.custAddress = "";
      this.custPass = "";
    },
    getRow(index, row) {
      this.modals = true;
      this.currentRow = row;
      this.custName = row.CustName;
      this.custPIC = row.CustPic;
      this.custAddress = row.CustAddr;
      this.custNo = row.CustNo;
      this.custEmail = row.CustEmail;
    },
    handleEdit(row) {
      console.log(row);
      swal({
        title: "Are you sure?",
        text: `You want to edit ${row.CustName}`,
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let body = {
            customername: this.custName,
            customerpassword: this.custPass,
            customeraddress: this.custAddress,
            customerphonenumber: this.custNo,
            customeremail: this.custEmail,
            customerpic: this.custPIC,
          };
          console.log(body);
          this.$http
            .put(`:9991/api/v1/customers/update/${row.CustID}`, body)
            .then((res) => {
              if (!res.error) {
                console.log(res.message);
                row.CustName = this.custName;
                row.CustNo = this.custNo;
                row.CustPic = this.custPIC;
                row.CustEmail = this.custEmail;
                row.CustAddr = this.custAddress;
              }
            });

          this.modals = false;
          swal({
            title: "Edited!",
            text: `You edited ${row.CustName}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(`:9991/api/v1/customers/${row.CustID}`)
            .then((res) => {
              if (!res.error) {
                console.log(res);
                this.deleteRow(row);
                swal({
                  title: "Deleted!",
                  text: `You deleted ${row.CustName}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              } else {
                swal({
                  title: "Error!",
                  text: res.message,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              }
            });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableCustomerData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableCustomerData.splice(indexToDelete, 1);
      }
    },
    getCustomer(row, column, event) {
      let custID = row.CustID;
      this.$router.push({ path: `/Greencard/PickupPointUpdate/${custID}` });
    },
    listCustomer() {
      this.$http.get(":9991/api/v1/customers/customerList").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let data = {
              id: i,
              CustName: response[i].CustName,
              CustAddr: response[i].CustAddr,
              CustNo: response[i].CustNo,
              CustPic: response[i].CustPic,
              CustEmail: response[i].CustEmail,
              CustID: response[i].CustID,
              TotalRegion: response[i].TotalRegion,
            };
            console.log(data);
            this.tableCustomerData.push(data);
          }

          console.log(this.tableCustomerData);
        } else {
          swal({
            title: "Data Error!",
            text: `No record available!`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            cancelButtonClass: "btn btn-danger btn-fill",
            confirmButtonText: "Okay!",
            buttonsStyling: false,
          });
        }
      });
    },
  },
  created() {
    this.listCustomer();
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableCustomerData, {
      keys: ["CustName"],
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableCustomerData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style lang="scss">
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
.group-form {
  border: solid red;
  border-radius: 20px;
  padding: 2%;
  margin-bottom: 2%;
  margin-right: 2%;
}
</style>
